import axios from 'axios'
import Auth from '@/services/auth'
import router from '@/router/index'

axios.interceptors.request.use(
  (config) => {
    const headers = Auth.getAuthHeaders()
    return {
      ...config,
      headers: {
        ...config.headers,
        ...(headers ? { Authorization: headers } : {}),
      },
    }
  },
  (error) => {
    return Promise.reject(error)
  },
)

const redirect401 = async (error) => {
  const originalRequest = error.config
  const { response } = error
  if (response.status === 401) {
    try {
      await Auth.checkAuth(true)
      const retry = await axios(originalRequest)
      return retry
    } catch (e) {
      // Message({
      //   message: 'Vous n’êtes plus connecté. Vous allez être redirigé vers la page de connexion',
      //   type: 'warning',
      // })
      // setTimeout(() => {
      //   router.push({ name: 'sign-in', query: { redirect: router.currentRoute.path, forceRedirect: true } })
      // }, 1300)

      router.push({ name: 'login', query: { redirect: router.currentRoute.path, forceRedirect: true } })
      // throw new Error(error)
    }
  } else {
    throw new Error(error)
  }
}
axios.interceptors.response.use(
  undefined,
  redirect401
)



// WEBPACK FOOTER //
// ./src/setup/axios.js